import React, { useRef, useState } from "react";
import * as styles from "./Login.module.css";
import { appConstants } from "../../utils";
import { IQ_HUB_AUTH_SERVICES } from "../../services";
import { checkValidate } from "../../utils";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import * as constant from "../../utils/constants";
import { FloatingInput } from "../Inputs";
import { showToast } from "../ToastComponent";
import { useNavigate } from "react-router-dom";
// import FloatingPassword from "../Inputs/FloatingPassword";

export const Login = ({ onLoginSuccess }) => {
  const email = useRef(null);
  const password = useRef(null);
  const navigate = useNavigate();

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      // Send token to backend for verification using fetch
      const response = await IQ_HUB_AUTH_SERVICES.IQGoogleLogin({
        token: credentialResponse.credential,
      });

      const data = await response.json();

      if (data.token) {
        localStorage.setItem(appConstants.IQ_HUB_TOKEN_NAME, data.token);
        if (onLoginSuccess) {
          onLoginSuccess(data.orgUserInfo);
        }
      }
      showToast(data?.message);
    } catch (error) {
      console.error("Google Authentication Failed:", error);
    }
  };

  const handleLoginError = () => {
    console.error("Google Login Failed");
  };

  const handleSubmit = async () => {
    const msg = checkValidate(email.current.value, password.current.value);
    if (msg) {
      showToast(msg);
      return;
    }

    try {
      const response = await IQ_HUB_AUTH_SERVICES.Login({
        email: email.current.value,
        password: password.current.value,
      });

      const data = await response.json();

      if (data.token) {
        localStorage.setItem(appConstants.IQ_HUB_TOKEN_NAME, data.token);
        if (onLoginSuccess) {
          onLoginSuccess(data.orgUserInfo);
        }
      } else {
        console.log(data.message);
      }
      showToast(data?.message);
    } catch (err) {
      console.log(err);
      // setMessage(err.message);                  Have to dispatch snackbar error component
    }
  };

  const signuproute = () => {
    navigate(constant.APP_ROUTE_SIGNUP);
  };

  const forgotpasswordroute = () => {
    navigate(constant.APP_ROUTE_FORGOT_PASSWORD);
  };

  return (
    <div>
      <h1 className={styles.sign_in_Heading}>Sign In</h1>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className={styles.form}
      >
        <FloatingInput label="Email" name="email" placeholder="" ref={email} />

        {/* <FloatingPassword ref={password} /> */}
        <FloatingInput
          label="Password"
          name="Password"
          placeholder=""
          ref={password}
          type="password"
          required
        />

        <div className={styles.forgot_password_container}>
          <a className={styles.forgot_password} onClick={forgotpasswordroute}>
            Forgot your password?
          </a>
        </div>

        <input
          onClick={handleSubmit}
          type="submit"
          value="Sign In"
          className={styles.submit_button}
        />

        <div className={styles.sign_up_container}>
          {`Don't have an account?`}
          <a className={styles.sign_up} onClick={signuproute}>
            Sign Up
          </a>
        </div>

        <div className={styles.or_container}>
          <hr />
          OR
          <hr />
        </div>

        <div className={styles.oauth_container}>
          <GoogleOAuthProvider clientId={appConstants.IQ_HUB_GOOGLE_CLIENT_ID}>
            <div className={styles.oauth_google_container}>
              <GoogleLogin
                onSuccess={handleLoginSuccess}
                onError={handleLoginError}
              />
            </div>
          </GoogleOAuthProvider>
        </div>
      </form>
    </div>
  );
};
